import { useService } from '../ServiceContext';
import { useTenant } from '../TenantContext';
import { useFeatureFlags } from '../FeatureFlagsContext';
import { FeatureFlags } from '../../flags';

export const useNotification = () => {
  const { post } = useService();
  const { getConfigValue } = useTenant();
  const { hasFeature } = useFeatureFlags();

  const hasEmailFeature = hasFeature(FeatureFlags.NGW_EMAIL);
  const hasEmailSellingAgentFeature = hasFeature(
    FeatureFlags.NGW_EMAIL_SELLING_AGENT,
  );

  const sendSellingAgentEmail = async (listingId: string, mlsIds: string[]) => {
    const sellingAgentEmailEnabled =
      hasEmailFeature && hasEmailSellingAgentFeature;

    if (!sellingAgentEmailEnabled) {
      return;
    }

    const matrixListingUrl = getConfigValue('MATRIX_LISTING_URL');

    try {
      const request = {
        channel: 'EMAIL',
        templateKey: 'selling-agent-notification',
        recipients: {
          fromMemberMlsId: [...mlsIds],
        },
        dataSource: {
          forListingId: listingId,
        },
        additionalData: {
          VIEW_LISTING_URL: matrixListingUrl + listingId,
        },
      };

      await post<any>('send-notification', {}, request);
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  return {
    sendSellingAgentEmail,
  };
};
